// Ensures the beginning slash exists, and it has no ending slash
export function normalizeSlug(slug?: string) {
  if (slug === undefined || !slug || slug === '/') return '/';

  const needsPrefix = !slug.startsWith('/');
  const hasSuffix = slug.endsWith('/');

  return `${needsPrefix ? '/' : ''}${hasSuffix ? slug.substring(0, slug.length - 1) : slug}`;
}
